import { render, staticRenderFns } from "./MultimediaModule.vue?vue&type=template&id=eda5d20c&scoped=true&"
import script from "./MultimediaModule.vue?vue&type=script&lang=js&"
export * from "./MultimediaModule.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaModule.scss?vue&type=style&index=0&id=eda5d20c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda5d20c",
  null
  
)

export default component.exports